document.addEventListener("DOMContentLoaded", function () {
    const menuItems = document.querySelectorAll(".body-procedures__item");

    menuItems.forEach((item) => {
        item.addEventListener("mouseenter", function () {
            this.querySelector('.body-procedures__content').classList.add("show-submenu");
        });

        item.addEventListener("mouseleave", function () {
            this.querySelector('.body-procedures__content').classList.remove("show-submenu");
        });
    });
});